
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppCustomViewTabFrames from "@/components/browse/CustomViewTabFrames.vue";
import { Contact } from "@/models/base";
import Vue from "vue";
import { createConfirmBuilder } from "../../setup/confirm-builder";
import AppTab2 from "./ContactEditAddresses.vue";
import AppTab1 from "./ContactEditDefault.vue";
import AppTab4 from "./ContactEditExtraInfo.vue";
import AppTab3 from "./ContactEditExtraFields.vue";
import AppTab5 from "./ContactEditAwsDocuments.vue";
import AppTab6 from "./ContactEditPriceRules.vue";
import { getContactServiceByGroupId } from "../../utils/services/contact-services";
import { ISelectItem } from "winfakt-vue-components";
import { v4 } from "uuid";
import {DossierConfigService, SaleService, UserConfigService} from "@/services";
import {ShopService} from "@/services/shop-service";
import { ContactService } from "@/utils/services/contact-service";
import {AuthService} from "@/services/auth-service";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			tab: 0,
			storedNextFriendlyId: {
				computedFriendlyId: "",
			},
			checkingVat: "",
			oldMainEmailAddress: ""
		};
	},
	props: {
		value: {
			type: Object as () => Contact,
			required: true
		},
		drawerButtonDisabled: Boolean,
		isInfo: Boolean
	},
	computed: {
		saveDisabled():boolean {
			if (!this.value.isVatValidForVatRegime()) {
				return true;
			}
			return false;
		},
		currentTab(): string {
			return this.tabs[this.tab];
		},
		tabs(): any {
			let t = Object.values(this.$ct("tabs"));
			let e = UserConfigService.getCustomViewTabs();
			let v = e.getTabNamesForBrowse(1);
			return [...t, ...v];
		},
		customViewTabs(){
			return UserConfigService.getCustomViewTabsForBrowse(1);
		},
		contact(): Contact {
			return this.value;
		},
		title():string {
			let titleKey = "titles.";

			let titleGroups = ["client", "supplier", "prospect"];
			titleKey += titleGroups[this.value.GroupID - 1];
			titleKey += "-";

			if (this.value.ID) {
				titleKey += "edit";
			} else {
				titleKey += "new";
			}
			return this.$ct(titleKey).toString();
		},
		lastLoadedDisabled():boolean{
			if (this.value.ID != 0){
				return true;
			}
			return !this.contactService.lastOpenedItem.hasStoredItem();
		},
		dropDownItems():ISelectItem<string>[]{
			return [{
				text: this.$ct("load-last-opened"),
				value: "load-last-opened",
				disabled: this.lastLoadedDisabled
			}];
		},
		contactService():ContactService{
			return getContactServiceByGroupId(this.value.GroupID);
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				if (this.value.MainAddress && this.value.MainAddress.Email){
					this.oldMainEmailAddress = (this.value.MainAddress.Email || "").split(";")[0];
				}
			}
		}
	},
	methods: {
		onUpdateParent(event:Contact){
			this.$emit("input", new Contact(event));
		},
		async checkIfMailAddressIsDifferentForFrequencyDocuments():Promise<string>{
			if (!AuthService.hasModule(MODULE.ABONNEMENTEN)) return "";
			if (this.value.ID == 0) return "";
			if (!this.value.MainAddress) return "";
			if (!this.value.MainAddress.Email) return "";
			let toEmailAddress = this.value.MainAddress.Email.split(";")[0];
			if (toEmailAddress == this.oldMainEmailAddress) return "";
			let count = await this.contactService.hasContactFrequencyDocumentsWithAutoSendEnabled(this.value.ID);
			if (count == 0) return "";
			let message = this.$ctc("ask-update-mail-address-of-frequency-documents", count, {type: this.$ct(`common.contact-group.${this.value.GroupID}`), email: toEmailAddress});
			let confirm = await this.$wf.confirm(message, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.info"));
			if (!confirm) return "";
			return toEmailAddress;
		},
		async save() {
			if (this.saveDisabled) return;
			if (this.contact.ID == 0 || this.contact.ID == undefined) {
				if (this.storedNextFriendlyId.computedFriendlyId != this.contact.ComputedFriendlyID) {
					this.contact.FriendlyID = 0;
				}
				var contact = (await this.contactService.postContact(this.contact));
			} else {
				let updateFrequencyDocumentEmail = await this.checkIfMailAddressIsDifferentForFrequencyDocuments();
				var contact = (await this.contactService.putContact(this.contact, {updateFrequencyDocumentEmail}));
			}

			if(DossierConfigService.getGeneralConfig().AutoShopSynch){
				await ShopService.contact(contact.ID);
			}

			contact = await this.contactService.getContact(contact.ID);
			this.$emit("input", contact);
			this.$emit("save");
			this.$wf.notify(this.$ct("save-success").toString(), "success", 3000, "check");
		},
		async cancel() {
			this.$emit("cancel");
		},
		async remove() {
			let contactService = getContactServiceByGroupId(this.value.GroupID);
			let confirm = await createConfirmBuilder.bind(this)(this.$ct("confirm-delete")).setTitle(this.$ct("common.warning")).setClass("warning").show();
			if (!confirm) return;
			let result = await contactService.delContacts([this.contact]);
			if (!result) {
				await this.$wf.dialog(this.$ct("error-cannot-delete"), this.$t("common.back"), this.$t("common.attention"), "warning");
			} else {
				this.$emit("delete");
				this.$wf.notify(this.$t("common.success").toString(), "success", 3000, "check");
			}
		},
		loadLastOpenedItem(){
			let contactService = getContactServiceByGroupId(this.value.GroupID);
			let contact = new Contact(contactService.lastOpenedItem.getLastOpenedItem());
			this.$emit("input", contact);
		},
		dropdownInput(value:string){
			if (value == "load-last-opened"){
				this.loadLastOpenedItem();
			}
		},
		async fetchFriendlyId(){
			if (this.contact.ID != 0) return;
			let contactService = getContactServiceByGroupId(this.contact.GroupID);
			let result = await contactService.getNextAvailableComputedID();
			this.storedNextFriendlyId.computedFriendlyId = result.computedFriendlyId;
			this.contact.FriendlyID = result.friendlyId;
			this.contact.ComputedFriendlyID = result.computedFriendlyId;
		},
		async checkIfVatExists():Promise<boolean>{
			let threadId = v4();
			try{
				this.checkingVat = threadId;
				if (!this.contact.Vat) return false;
				let contactService = getContactServiceByGroupId(this.contact.GroupID);
				let contacts = await contactService.getByVat(this.contact.Vat);
				if (this.checkingVat != threadId) return false;
				for (let contact of contacts) {
					if (contact.ID == this.contact.ID) {
						return true;
					}
				}
				if (contacts.length) {
					let message = this.$ct("exists-vat-confirm");
					await this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.warning"), "warning");
				}
				return true;
			}catch(err){

			}finally{
				if (this.checkingVat == threadId) {
					this.checkingVat = "";
				}
			}
			return false;
		},
		checkIfCanEdit(){
			if (this.contact.ID == 0) return;
			let types = SaleService.getTypes();
			let errors:string[] = [];
			for (let t of types) {
				let conf = DossierConfigService.getSaleConfig(t);
				if (conf.DefaultContactID == this.contact.ID) {
					errors.push(this.$ct("error-cant-edit-cause-default-contact-for-sale-type", {saleType: t.DisplayedName}).toString());
				}
			}
			if (errors.length == 0) {
				return;
			}
			let message = this.$ctc("error-cant-edit-this-contact-because", errors.length);
			message = [message, ...errors].join("<br/>");
			this.$wf.dialog(message, this.$ct("common.Ok"), this.$ct("common.error"), "warning");
			this.cancel();
		}
	},
	async mounted(){
		await this.fetchFriendlyId();
		this.checkIfCanEdit();
	},
	components: {
		AppTab1,
		AppTab2,
		AppTab3,
		AppTab4,
		AppTab5,
		AppToolbar,
		AppMobileFullScreenContainer,
		AppTab6,
		AppCustomViewTabFrames
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}

});
